var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowEmailTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7102_1893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7102_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1112 53.3333C25.3612 53.3333 24.7106 53.0579 24.1595 52.5071C23.6087 51.956 23.3333 51.3054 23.3333 50.5554V29.4446C23.3333 28.6946 23.6087 28.044 24.1595 27.4929C24.7106 26.9421 25.3612 26.6667 26.1112 26.6667H53.8887C54.6387 26.6667 55.2892 26.9421 55.8403 27.4929C56.3912 28.044 56.6666 28.6946 56.6666 29.4446V50.5554C56.6666 51.3054 56.3912 51.956 55.8403 52.5071C55.2892 53.0579 54.6387 53.3333 53.8887 53.3333H26.1112ZM39.9999 41.0554L26.1112 32.0833V50.5554H53.8887V32.0833L39.9999 41.0554ZM39.9999 38.2779L53.7778 29.4446H26.2499L39.9999 38.2779ZM26.1112 32.0833V29.4446V50.5554V32.0833Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowEmailTemplates);
export default __webpack_public_path__ + "static/media/icon-flow-email-templates.5bad65c88707d05968e9c58f261ece52.svg";
export { ForwardRef as ReactComponent };